<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="align-left">
      <small class="text-muted">Stock On Hand</small>
    </h3>
    <div class="dropdown-divider"></div><br />
    <app-data-search v-on:searching="search"></app-data-search>
    <button type="button" class="btn btn-outline-success" @click="preview">Print all stock <i class="fas fa-print"></i></button>
    
    <br /><br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="stock" v-on:selectedRow="selectRow"></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { StockOnHand } from '../../models/stock'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
      return {
        stock: [StockOnHand],
        dtElements: [
          {
            title: 'Product Name',
            column: 'productName',
            type: 'text'
          },
          {
            title: 'Warehouse Name',
            column: 'warehouseName',
            type: 'text'
          },
          {
            title: 'Qty On Hand',
            column: 'qty',
            type: 'text'
          },
        ],
        selectedId: '',
        searchKey: '',
        pagination: {
          pageSize: 10,
          currentPage: 1
        }
      }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const stockApi = api('view/stock-on-hand')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      this.stock = await stockApi.getWithQuery(query) 
    },
    async preview() {
      const excelApi = api('print/stock-on-hand')
      const excelFile = await excelApi.getFileWithoutQuery()
      download(excelFile, 'Report-Stock-On-Hand.xlsx')
    },
    selectRow(id) {
      this.selectedId = id
    },
    changePage(payload) {
      this.pagination = payload
      this.init()
    },
    search(searchKey) {
      this.searchKey = searchKey
      this.init()
    }
  }
}
</script>